import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ArrowsRightLeft from '@/assets/ArrowsRightLeft.svg';

const ArrowRightLeft = ({ size, variant, className }: IconProps) => (
  <img
    src={ArrowsRightLeft}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ArrowRightLeft;
